import type { Region } from './model';

/**
 * The JBCH USA churches: a copy of the production DynamoDB table `churches` (owned by the counseling app; never written
 * by this app). `id` is that table's id, kept on each church list entry as `churchId`. In AWS the list is loaded from the
 * table itself (infra/scripts/load-lists.ts); this copy seeds local dev and tests.
 */
export const CHURCHES: readonly { id: string; name: string; region: Region }[] = [
  { id: '2942d6e2-1295-4206-8c45-bb32c2cac0a7', name: 'Asheville', region: 'East' },
  { id: '119c2e35-685a-482a-9ee3-680067fa8200', name: 'Atlanta', region: 'East' },
  { id: 'cd803e89-7879-4501-a587-99ec2ba96c16', name: 'Chicago', region: 'East' },
  { id: '7a1ce40a-5678-45c1-8b12-ce1689f5823c', name: 'Kentucky', region: 'East' },
  { id: '5d7bff9c-180a-445b-aef2-81b4ff08a633', name: 'Michigan', region: 'East' },
  { id: 'b21927a0-c816-4578-ae34-98201344d81d', name: 'New Jersey', region: 'East' },
  { id: '32fd028c-99fb-4c04-92b0-00d87fdf4510', name: 'New York', region: 'East' },
  { id: '2bba54c7-adbc-4595-bb19-6f7ec7bd0f1c', name: 'Orlando', region: 'East' },
  { id: '2aa8e364-24f0-480d-98a6-ca6c271ffb1f', name: 'S. Illinois', region: 'East' },
  { id: '37466092-888c-455b-8833-2149c2bb590d', name: 'S. Virginia', region: 'East' },
  { id: 'ca497054-0189-4ee0-8f47-f56553c2c0a6', name: 'Washington', region: 'East' },
  { id: '2c33aa3d-25f5-4b46-81f7-5f606c16895d', name: 'Colorado', region: 'Central' },
  { id: 'c1256c3e-d051-4f2c-a593-71bf574024bc', name: 'Dallas', region: 'Central' },
  { id: '69b471af-e681-468a-8d89-307726cacaa2', name: 'Denver', region: 'Central' },
  { id: 'fcc2da4f-a32b-42f9-81e8-d1b1c22e7a95', name: 'Houston', region: 'Central' },
  { id: 'aabf9a38-a4b8-4cd5-8165-138f76a52ded', name: 'Lawton', region: 'Central' },
  { id: '97f0b5d6-3e6a-4374-b6c8-53ff26d68542', name: 'San Antonio', region: 'Central' },
  { id: '66e7130a-baf9-4b16-9d9f-4a5af123dd40', name: 'LA', region: 'West' },
  { id: '5e6810a8-0cb3-45e5-81f6-93a918f255ae', name: 'LA Central', region: 'West' },
  { id: '9af87349-4574-455e-ba75-4d4637d28120', name: 'LA Corona', region: 'West' },
  { id: '4d4c31b8-3645-47f0-886f-1eec155c138d', name: 'Las Vegas', region: 'West' },
  { id: '87666265-54de-4537-b741-949f22921d75', name: 'San Francisco', region: 'West' },
];

/** Church tag name from a church name: 'New York' → 'new-york', 'S. Illinois' → 's-illinois', 'LA Central' → 'la-central'. */
export function churchTag(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
